import { render, staticRenderFns } from "./bottomContent.vue?vue&type=template&id=60bb150a&scoped=true"
import script from "./bottomContent.vue?vue&type=script&lang=js"
export * from "./bottomContent.vue?vue&type=script&lang=js"
import style0 from "./bottomContent.vue?vue&type=style&index=0&id=60bb150a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60bb150a",
  null
  
)

export default component.exports